module.exports = __webpack_public_path__ + "static/media/fog_of_war.58712b8f.png";